export class ShiftDayTimeDTO {
    ShiftId: string;
    Title: string;
    Notes: string;
    AddToCalendar: boolean;
    StartDate: string;
    StartTime: string;
    Start: string;
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/ShiftDayTime.model.ts